import { t } from "i18next";
import { useRegisterSW } from "virtual:pwa-register/react";

import { Notify } from "~/components/ui/notify/notify";

// interval between each call to the Service Worker
const intervalMS = 2 * 60 * 1000;

function registerPeriodicSync(swUrl: string, r: ServiceWorkerRegistration) {
  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  setInterval(async () => {
    if ("onLine" in navigator && !navigator.onLine) return;
    if (document.visibilityState !== "visible") return;

    try {
      const resp = await fetch(swUrl, {
        cache: "no-store",
        headers: {
          "cache-control": "no-cache",
        },
      });

      if (resp.status === 200) await r.update();
    } catch {
      // Network failures are expected (e.g. right after iOS resumes a
      // backgrounded tab); the next tick will retry.
    }
  }, intervalMS);
}

export function AppUpdater() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, r) {
      if (!r) return;

      if (r.active?.state === "activated") {
        registerPeriodicSync(swUrl, r);
      } else if (r.installing) {
        r.installing.addEventListener("statechange", (e) => {
          const sw = e.target as ServiceWorker;
          if (sw.state === "activated") registerPeriodicSync(swUrl, r);
        });
      }
    },
  });

  if (needRefresh) {
    return (
      <Notify
        title={t("update.new_version")}
        description={t("update.refresh_page")}
        onClick={() => {
          updateServiceWorker(true);
          setNeedRefresh(false);
        }}
      />
    );
  }

  return null;
}
